/* KudzuSeeds link logic. Added 16 September 2026 (theme KS v25), ported from Chemiseed cs-links.js (v21).
   1. Outbound links get UTM parameters at the moment they are used (pointerdown, keydown, click):
      utm_source=kudzuseeds.com, utm_medium=referral, utm_campaign=site-<locale>-<market>-<page group>,
      utm_content=<placement>-<page handle>. Internal links are never tagged. Links that already carry
      utm_ parameters, links marked data-no-utm, WhatsApp links, archive.org links, share intents and
      the store's own CDN files are left alone.
   2. Every CTA click pushes one dataLayer event, ks_cta_click, with cta_type, cta_label, link_url,
      link_domain and link_placement. Tag Manager forwards it to GA4 and adds the page context
      (ks_page_group, ks_page_handle, ks_locale, ks_market) that layout/theme.liquid pushes before GTM loads.
   3. The first WhatsApp click of a session also pushes generate_lead with method whatsapp, once per
      session (sessionStorage), replacing the gated rule that used to live in layout/theme.liquid.
   4. The same page context is set as Microsoft Clarity custom tags once Clarity has loaded.
   No personal data is read or written.
   10 Oct 2026 (K-24, KZU-04, KZU-18, KZU-33):
   - WhatsApp buttons that are not wa.me links (href="#" or no href, carrying data-wa="<number>", class ks-wa-btn)
     are tracked exactly like a wa.me link: ks_cta_click with cta_type whatsapp, and generate_lead on the first
     WhatsApp tap of the session. The button's own script still opens WhatsApp; nothing here changes navigation.
   - Citation and reference links (DOI, government, university, journal and publisher hosts, PDF files, links inside a
     reference list or styled as a citation) are no longer given UTM parameters; their clicks are still tracked.
   - /pages/become-a-distributor and /pages/government-b2g have no form, so links to them are not counted as quote_form. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) { return; }
  var d = document, L = window.location;
  var ctx = window.ksPage || {};
  var OWN = /(^|\.)kudzuseeds\.com$/i;
  var WA = /(^|\.)(wa\.me|whatsapp\.com)$/i;
  var SKIP = /(^|\.)(wa\.me|whatsapp\.com|archive\.org|cdn\.shopify\.com|shopifycdn\.com)$/i;
  var SHARE = /(linkedin\.com\/sharing|twitter\.com\/intent|x\.com\/intent|facebook\.com\/sharer|facebook\.com\/dialog|wa\.me\/\?text=)/i;
  var SOCIAL = /(^|\.)(facebook\.com|fb\.com|instagram\.com|tiktok\.com|linkedin\.com|youtube\.com|youtu\.be|twitter\.com|x\.com|substack\.com|threads\.net)$/i;
  var SHOPEE = /(^|\.)(shopee\.[a-z.]+|lazada\.[a-z.]+)$/i;
  var CS = /(^|\.)chemiseed\.com$/i;
  /* 9 Oct 2026: [a-z]{2,3} so the Filipino folder (/fil/) is recognised; it was [a-z]{2}, which classified
     /fil/pages/sample-request and the /fil/ tool pages as plain internal links. */
  var LOC = '^\\/(?:[a-z]{2,3}(?:-[a-z]{2})?\\/)?';
  var LEAD = new RegExp(LOC + 'pages\\/(contact|consultation-request|distributor-application|sample-request|bulk-order|field-trial-request|institutional-buyer-intake)(?:$|[\\/?#])', 'i');
  /* Citation and reference hosts: never tagged with UTMs (adapted from Chemiseed cs-links.js, 10 Oct 2026). */
  var CITE_TLD = /(^|\.)(gov|edu)(\.[a-z]{2})?$|(^|\.)(ac|go|gob|gouv|govt)\.[a-z]{2}$/i;
  var CITE_HOST = /(^|\.)(doi\.org|europepmc\.org|sciencedirect\.com|springer\.com|wiley\.com|mdpi\.com|frontiersin\.org|tandfonline\.com|cambridge\.org|oup\.com|nature\.com|researchgate\.net|academia\.edu|jstor\.org|crossref\.org|semanticscholar\.org|tropicalforages\.info|fao\.org|cgiar\.org|cabi\.org|cabidigitallibrary\.org|iopscience\.iop\.org|agritrop\.cirad\.fr|prota4u\.org)$/i;
  var CITE_ANY = /pubmed|scholar\.google\.|plantuse|prota4u|pertanika|journal|scielo|ajol\.info|doaj\.org|arxiv\.org|biorxiv\.org|ssrn\.com|plos\.org|hindawi\.com|sagepub\.com|elsevier\.com/i;
  var REF_SEL = 'cite, .references, .reference-list, .refs, .crs-cite, .crs-foot, [class*="-cite"], [class*="__cite"], [data-cite], .footnotes, #references, [role="doc-bibliography"], [role="doc-endnotes"]';
  var WA_SEL = '[data-wa], .ks-wa-btn';
  var TOOL = new RegExp(LOC + 'pages\\/(tools|unit-converter|[a-z0-9-]*calculator[a-z0-9-]*|[a-z0-9-]*checker[a-z0-9-]*|[a-z0-9-]*planner[a-z0-9-]*)(?:$|[\\/?#])', 'i');
  var DOC = new RegExp(LOC + '(pages\\/(e-catalogue|e-catalog|document-center|knowledge-hub|evidence-hub)|files\\/)(?:$|[\\/?#.])', 'i');
  var CTA = '[data-ks-cta], .button, .btn, [role="button"], [class*="cta"], [class*="button"], [class*="__link--primary"], .ks-mobilebar a, #ks-mobilebar a';

  function clean(v, max) {
    v = String(v == null ? '' : v).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return v.slice(0, max || 60).replace(/-+$/g, '');
  }
  function group() { return clean(ctx.page_group || ctx.page_type || 'page', 30) || 'page'; }
  function campaign() {
    return 'site-' + (clean(ctx.locale, 5) || 'en') + '-' + (clean(ctx.market, 5) || 'ph') + '-' + group();
  }
  function placement(a) {
    var c = function (s) { try { return a.closest(s); } catch (e) { return null; } };
    if (c('#ks-mobilebar, .ks-mobilebar')) { return 'mobilebar'; }
    if (c('#ks-anchornav, .ks-anchornav')) { return 'anchornav'; }
    if (c('#whatsappButton, .whatsapp-float, .ks-wa-btn')) { return 'whatsapp-button'; }
    if (c('.announcement-bar, [id^="shopify-section-"][id*="announcement"]')) { return 'announcement'; }
    if (c('header, .header, .menu-drawer, [id^="shopify-section-"][id*="__header"]')) { return 'header'; }
    if (c('footer, .footer, [id^="shopify-section-"][id*="__footer"]')) { return 'footer'; }
    var s = c('[id^="shopify-section-"]');
    if (s && s.id) {
      var id = s.id, i = id.lastIndexOf('__');
      return clean(i > -1 ? id.slice(i + 2) : id.replace('shopify-section-', ''), 30) || 'body';
    }
    return 'body';
  }
  function content(a) {
    var h = clean(ctx.handle, 40);
    return placement(a) + (h ? '-' + h : '');
  }
  function label(a) {
    var t = a.getAttribute('aria-label') || a.getAttribute('title') || (a.textContent || '');
    if (!t.trim()) { var img = a.querySelector('img[alt]'); if (img) { t = img.getAttribute('alt') || ''; } }
    return t.replace(/\s+/g, ' ').trim().slice(0, 100);
  }
  function parse(a) {
    var href = a.getAttribute('href');
    if (!href) { return null; }
    href = href.trim();
    if (/^(javascript:|#)/i.test(href)) { return null; }
    var u;
    try { u = new URL(href, L.href); } catch (e) { return null; }
    return { raw: href, u: u, host: (u.hostname || '').toLowerCase(), proto: u.protocol };
  }
  function classify(p) {
    if (!p) { return null; }
    if (p.proto === 'tel:') { return 'phone'; }
    if (p.proto === 'mailto:') { return 'email'; }
    if (p.proto !== 'http:' && p.proto !== 'https:') { return null; }
    if (WA.test(p.host)) { return 'whatsapp'; }
    var path = p.u.pathname || '/';
    if (OWN.test(p.host) || p.host === L.hostname.toLowerCase()) {
      if (LEAD.test(path)) { return 'quote_form'; }
      if (TOOL.test(path)) { return 'tool'; }
      if (DOC.test(path) || /\.pdf($|\?)/i.test(path)) { return 'document'; }
      return 'internal';
    }
    if (/(^|\.)(cdn\.shopify\.com|shopifycdn\.com)$/i.test(p.host) || /\.pdf($|\?)/i.test(path)) { return 'document'; }
    if (SHOPEE.test(p.host)) { return 'marketplace'; }
    if (CS.test(p.host)) { return 'chemiseed'; }
    if (SOCIAL.test(p.host)) { return 'social'; }
    return 'outbound';
  }
  function decorate(a, p) {
    if (a.__ksUtm || !p) { return; }
    if (p.proto !== 'http:' && p.proto !== 'https:') { return; }
    if (OWN.test(p.host) || p.host === L.hostname.toLowerCase()) { return; }
    if (SKIP.test(p.host) || SHARE.test(p.u.href)) { return; }
    if (a.hasAttribute('data-no-utm')) { return; }
    if (isCitation(a, p)) { a.__ksUtm = 1; return; }
    if (/[?&]utm_[a-z_]+=/i.test(p.u.search)) { a.__ksUtm = 1; return; }
    var qs = 'utm_source=kudzuseeds.com&utm_medium=referral&utm_campaign=' + encodeURIComponent(campaign()) + '&utm_content=' + encodeURIComponent(content(a));
    var raw = p.raw, hi = raw.indexOf('#'), base = hi > -1 ? raw.slice(0, hi) : raw, hash = hi > -1 ? raw.slice(hi) : '';
    if (/\?$/.test(base)) { base += qs; } else { base += (base.indexOf('?') > -1 ? '&' : '?') + qs; }
    a.setAttribute('href', base + hash);
    a.__ksUtm = 1;
  }
  function isCitation(a, p) {
    if (CITE_TLD.test(p.host) || CITE_HOST.test(p.host) || CITE_ANY.test(p.host)) { return true; }
    if (/\.pdf($|[?#])/i.test(p.u.pathname || '')) { return true; }
    try { return !!a.closest(REF_SEL); } catch (e) { return false; }
  }
  function waButtonOf(e) {
    var t = e.target;
    if (!t || !t.closest) { t = t && t.parentElement; }
    if (!t || !t.closest) { return null; }
    var b = t.closest(WA_SEL);
    if (!b) { return null; }
    var n = String(b.getAttribute('data-wa') || '').replace(/[^0-9]/g, '');
    if (n.length < 8) { n = '60172374058'; }
    return { el: b, number: n, msg: b.getAttribute('data-msg') || '' };
  }
  function anchorOf(e) {
    var t = e.target;
    if (!t || !t.closest) { t = t && t.parentElement; }
    return t && t.closest ? t.closest('a[href]') : null;
  }
  function isCta(a) { try { return !!a.closest(CTA); } catch (e) { return false; } }
  function prepare(e) {
    var a = anchorOf(e); if (!a) { return; }
    decorate(a, parse(a));
  }
  function firstThisSession(key) {
    try {
      if (sessionStorage.getItem(key)) { return false; }
      sessionStorage.setItem(key, '1');
      return true;
    } catch (e) { return true; }
  }
  function clarity(fn) {
    var tries = 0;
    (function tick() {
      if (typeof window.clarity === 'function') { try { fn(window.clarity); } catch (e) {} return; }
      if (++tries < 40) { setTimeout(tick, 250); }
    })();
  }
  function trackWaButton(w) {
    var where = placement(w.el);
    var url = 'https://wa.me/' + w.number + (w.msg ? '?text=' + w.msg : '');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ks_cta_click',
      cta_type: 'whatsapp',
      cta_label: label(w.el),
      link_url: url.slice(0, 500),
      link_domain: 'wa.me',
      link_placement: where
    });
    if (firstThisSession('ks_wa_lead')) {
      window.dataLayer.push({
        event: 'generate_lead',
        event_category: 'lead_gen',
        method: 'whatsapp',
        link_placement: where
      });
    }
    clarity(function (c) { c('set', 'cta_type', 'whatsapp'); c('event', 'cta_click'); });
  }
  function track(e) {
    if (e.type === 'auxclick' && e.button !== 1) { return; }
    var a = anchorOf(e);
    var p = a ? parse(a) : null;
    if (!p) {
      /* A WhatsApp button without a usable wa.me href (href="#" plus window.open, or a <button>). */
      var w = waButtonOf(e);
      if (w) { trackWaButton(w); }
      return;
    }
    decorate(a, p);
    var type = classify(p); if (!type) { return; }
    if (type === 'internal') { if (!isCta(a)) { return; } type = 'internal_cta'; }
    var href = a.getAttribute('href') || '';
    var where = placement(a);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ks_cta_click',
      cta_type: type,
      cta_label: label(a),
      link_url: href.slice(0, 500),
      link_domain: p.host || L.hostname,
      link_placement: where
    });
    if (type === 'whatsapp' && firstThisSession('ks_wa_lead')) {
      window.dataLayer.push({
        event: 'generate_lead',
        event_category: 'lead_gen',
        method: 'whatsapp',
        link_placement: where
      });
    }
    clarity(function (c) { c('set', 'cta_type', type); c('event', 'cta_click'); });
  }
  d.addEventListener('pointerdown', prepare, true);
  d.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { prepare(e); } }, true);
  d.addEventListener('click', track, true);
  d.addEventListener('auxclick', track, true);
  clarity(function (c) {
    if (ctx.page_group) { c('set', 'page_group', String(ctx.page_group)); }
    if (ctx.handle) { c('set', 'page_handle', String(ctx.handle)); }
    if (ctx.locale) { c('set', 'locale', String(ctx.locale) + (ctx.market ? '-' + ctx.market : '')); }
  });
  window.ksLinks = { classify: function (a) { return classify(parse(a)); }, decorate: function (a) { decorate(a, parse(a)); return a.getAttribute('href'); }, campaign: campaign, placement: placement };
})();
